import { FC, ReactElement } from 'react'
import loadingGif from '../../../../assets/gif/loader-ecommander-transparent.gif'
import '../../../ui/components/lc-loader/lc-loader.scss'

/**
 * Shown while react-i18next Suspense waits for HTTP-loaded namespaces.
 * Must not call useTranslation — i18n resources are not ready yet during this phase.
 */
export const I18nSuspenseFallback: FC = (): ReactElement => (
  <div>
    <div className="loaderBackground" />
    <div className="loaderWrapper">
      <img className="loader-logo" src={loadingGif} alt="" />
    </div>
  </div>
)
